import authentication from "@irati/auth"
import {PaymentCurrencyType, Recognition, WalletEntityType} from "@irati/types"
import RecognitionService from "@irati/recognition/services/Recognition"
import flexiPointService from "@irati/wallet/services/flexiRewards"
import walletService from "@irati/wallet/graph/wallet"

const attachRewardToRecognition = async (destinationUserIds: string[], pointsPerUser: number, recognition: Recognition) => {
  const wallet = await walletService.get(authentication.user().uuid!, PaymentCurrencyType.Rp, WalletEntityType.Reward)

  const variables = {
    sourceId: wallet.uuid!,
    destinationUserIds,
    amount: pointsPerUser * 100,
    message: recognition.message!
  }
  const totalAmount = pointsPerUser * destinationUserIds.length
  if (wallet.availableBalance! < totalAmount) {
    return
  }
  const {transferIds} = await flexiPointService.rewardEmployees(variables)
  const {status} = await flexiPointService.getTransferOutcome(transferIds[0])
  if (status !== "COMPLETE") {
    throw Error("Transfer failed")
  }
  return RecognitionService.updateRecognitionWithReward(recognition.uuid!, transferIds[0])
}

export default attachRewardToRecognition
